import type { SignatureData } from "../../service/forms/config-generics/signature";
import type { SVGProcessData, SVGSourceData } from "./svg-config";

export function getSignatureSVGLines(data: SignatureData): SVGProcessData {
    const { signed: _signed, ...remainingData } = data;

    return {
        svgLines: [{ src: data.signed }],
        remainingData: (remainingData as unknown) as SVGSourceData,
    };
}
